import * as types from '../mutation-types';

// state
export const state = {
  actionsMenuVisible: true,
  'actions': {
    refresh: false,
    status: null,
    showSearch: false,
  },
  'properties': {
    showSearch: false,
  },
  'new-and-renewals': {
    showSearch: false,
  },
  'jobs': {
    showSearch: false,
  },
  'job-requests': {
    showSearch: false,
  },
  'client-actions': {
    refresh: false,
    status: null,
    showSearch: false,
  },
  'client-assets-properties': {
    refresh: false,
    status: null,
    showSearch: false,
  },
  'property-assets': {
    refresh: false,
    status: null,
    showSearch: false,
  },
  'property-action-grid': {
    refresh: false,
    status: null,
    showSearch: false,
  },
  'property-client-action-grid': {
    refresh: false,
    status: null,
    showSearch: false,
  }
};

// mutations
export const mutations = {
  [types.REFRESHING_ACTION_GRID](state) {
    state.actions.refresh = true;
  },
  [types.REFRESHING_ACTION_GRID_COMPLETE](state) {
    state.actions.refresh = false;
  },
  [types.SETTING_ACTION_STATUS_FILTER](state, status) {
    state.actions.status = status;
  },
  [types.TOGGLE_ACTION_SEARCH](state) {
    state.actions.showSearch = !state.actions.showSearch;
  },
  [types.TOGGLE_PROPERTY_SEARCH](state) {
    state.properties.showSearch = !state.properties.showSearch;
  },
  [types.SETTING_ACTION_ACTIONS_MENU_VISIBLE](state, visible) {
    state.actionsMenuVisible = visible;
  },
};

// actions
export const actions = {
  refreshActions({ commit }) {
    commit(types.REFRESHING_ACTION_GRID);
  },
  refreshActionsComplete({commit}) {
    commit(types.REFRESHING_ACTION_GRID_COMPLETE);
  },
  setActionsFilter({ commit }, { status }) {
    commit(types.SETTING_ACTION_STATUS_FILTER, status);
  },
  searchActionClicked({ commit }) {
    commit(types.TOGGLE_ACTION_SEARCH);
  },
  searchPropertyClicked({ commit }) {
    commit(types.TOGGLE_PROPERTY_SEARCH);
  },
  searchJobClicked({ commit }) {
    commit(types.TOGGLE_JOB_SEARCH);
  },
  searchJobRequestClicked({ commit }) {
    commit(types.TOGGLE_JOB_REQUEST_SEARCH);
  },
  setActionsMenuVisibility({ commit }, visible) {
    commit(types.SETTING_ACTION_ACTIONS_MENU_VISIBLE, visible);
  },
};

// getters
export const getters = {
  actionRefresh: state => state.actions.refresh,
  actionStatusFilter: state => state.actions.status,
  actionShowSearch: state => state.actions.showSearch,
  propertyShowSearch: state => state.properties.showSearch,
  actionsMenuVisible: state => state.actionsMenuVisible,
};
